import React from "react";

import cn from "classnames";

import { boxForwardRef } from "../../../../../helpers/common/Box/Box";
import { TextCore } from "../../../../../helpers/common/TextCore/TextCore";
import { LABEL_MIXIN_BY_BUTTON_SIZE_MAP } from "../../constants/sizes";

import type { BoxComponentWithDefault } from "../../../../../helpers/common/Box/Box";
import type { OmitOfUnion } from "../../../../../types/react";
import type { TextProps } from "../../../../Text";
import type { ButtonSizes } from "../../types";

import classes from "./ButtonLabel.styl";

const BUTTON_LABEL_TEST_ID = "button-label-test-id";

export type ButtonLabel = OmitOfUnion<
    TextProps,
    | "typographyStyle"
    | "maxLines"
    | "asList"
    | "quote"
    | "textCase"
    | "underline"
    | "alignmentX"
    | "width"
    | "lineHeight"
>;

export const ButtonLabel = boxForwardRef<
    BoxComponentWithDefault<"span", ButtonLabel, "className">
>((props, ref): JSX.Element | null => {
    // buttonSize получаем из getChildrenRecord
    const { buttonSize, customVarsStyles, children, ...restProps } =
        props as ButtonLabel & {
            buttonSize?: ButtonSizes;
        };

    return children ? (
        <TextCore
            data-tsid={BUTTON_LABEL_TEST_ID}
            {...restProps}
            typographyStyle={
                buttonSize && LABEL_MIXIN_BY_BUTTON_SIZE_MAP[buttonSize]
            }
            maxLines={1}
            textContainerClassName={classes["button-label"]}
            customVarsStyles={cn(
                classes["custom-vars-styles"],
                customVarsStyles,
            )}
            ref={ref}
        >
            {children}
        </TextCore>
    ) : null;
});

ButtonLabel.displayName = "Button.Label";

export default ButtonLabel;
